import { render, staticRenderFns } from "./MandatForm.vue?vue&type=template&id=ed453f2e&"
import script from "./MandatForm.vue?vue&type=script&lang=js&"
export * from "./MandatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports